import React from 'react';
import { Button, ButtonProps } from 'rsuite';
import CheckIcon from '@rsuite/icons/Check';
import CloseIcon from '@rsuite/icons/Close';

import './styles.scss';
import { FaClock } from 'react-icons/fa';

type StatusVariant = 'success' | 'cancelled' | 'pending' | 'failed';

type StatusButtonProps = Omit<ButtonProps, 'appearance' | 'color'> & {
  variant: StatusVariant;
  // eslint-disable-next-line react/require-default-props
  label?: string;
};

const COLOR_MAP: Record<StatusVariant, string> = {
  success: '#16a34a', // green-600
  cancelled: '#ef4444', // red-500
  failed: '#ef4444', // red-500
  pending: '#D69A00', // yellow
};

export const StatusButton: React.FC<StatusButtonProps> = ({
  variant,
  label = null,
  ...rest
}) => {
  const color = COLOR_MAP[variant];

  return (
    <Button
      {...rest}
      className="status-btn"
      appearance="subtle"
      style={
        {
          // expose color to CSS
          '--status-color': color,
        } as React.CSSProperties
      }
    >
      <span className="status-btn__icon" aria-hidden>
        {variant === 'success' && <CheckIcon />}
        {(variant === 'cancelled' || variant === 'failed') && <CloseIcon />}
        {variant === 'pending' && <FaClock />}
      </span>
      <span>{label ?? String(variant).toUpperCase()}</span>
    </Button>
  );
};

export default StatusButton;
